import {forEach} from 'lodash'
import {TaxRefund, PerYear, PerYearStatement, TaxRefundResultResponse} from './types'

/**
 * Return PerYearStatement
 * @param perYearMap
 */
export function getPerYearStatement(
  perYearMap: {}
): PerYearStatement {
    const perYear: PerYear[] = []
    let expected = 0
    forEach(perYearMap, (value, key) => {
      if(key !== 'expected') {
        perYear.push({
          year: key,
          amount: value
        })
        expected += value
      }
    })
    return {
      perYear,
      expected
    }
}

/**
 * Return TaxRefund
 * @param result
 */
 export function resultToTaxRefund(
    result: TaxRefundResultResponse
  ): TaxRefund {
      const salesPerYear = getPerYearStatement(result.salesPerYear)
      const taxPerYear = getPerYearStatement(result.taxPerYear)
      const refundPerYear = getPerYearStatement(result.refundPerYear)
      return {
        bizNo: result.bizNo,
        refund: result.refund,
        refundDeclareYear: result.refundDeclareYear,
        refundStartYear: result.refundStartYear,
        refundEndYear: result.refundEndYear,
        salesPerYear: salesPerYear.perYear,
        salesExpected: salesPerYear.expected,
        taxPerYear: taxPerYear.perYear,
        taxExpected: taxPerYear.expected,
        refundPerYear: refundPerYear.perYear,
        refundExpected: refundPerYear.expected,
      }
  }
  